/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import { useParams, useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import { Button, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import confirm from "../../components/DialogComponent/confirm";
import { confirmnew } from "../../components/DialogComponent/confirmnew";
import PageTitle from "../../components/pageTitle/PageTitle";

import CommonContext from "../../hooks/commonContext";

import {
  addClient,
  updateClient,
  getClient,
  deleteClient,
  uploadLogo,
} from "../../services/apiservices/client";
import { EventEmitter } from "../../services/event.service";
import Step1 from "./CreateClientSteps/Step1";
import Step2 from "./CreateClientSteps/Step2";
import Step3 from "./CreateClientSteps/Step3";
import Step4 from "./CreateClientSteps/Step4";
import { getUniqueArray } from "../../services/helpers";
import AuthContext from "../../hooks/authContext";
import { forgotPasswordUser } from "../../services/firebase";
import styles from "./clients.module.scss";
import { useMediaQuery } from "@mui/material";
import { RotateCcw, Trash2 } from "lucide-react";
import Step5 from "./CreateClientSteps/Step5";
import { useToast } from "../../hooks/useToast";
import { getEmployee } from "../../services/apiservices/employee";
import { getSettings } from "../../services/apiservices/settings";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  complated: {
    background: "#078037",
    color: "#ffffff",
    borderTopColor: "transparent",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    // flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    marginLeft: "auto",
    // fontSize: theme.typography.pxToRem(15),
    // color: theme.palette.text.secondary,
    // opacity: "0.6",
  },
}));

const CreateClient = (props) => {
  const classes = useStyles();
  const commonContext = useContext(CommonContext);
  const loading = false;
  const [stepContentValues, setStepContentValue] = useState({});
  const [editData, setEditData] = useState(false);
  const [companyData, setCompanyData] = useState();
  const [settingsData, setSettingData] = useState();
  const [stepError, setStepError] = useState({});
  const auth = useContext(AuthContext);
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const [currentStep, setCurrentStep] = useState(1);
  const companyIds =
    auth?.userProfile?.role === "superUser"
      ? stepContentValues?.companyId
      : companyId;
      let history = useNavigate();
  const [stepContent, setStepContent] = useState({
     summaryReportFrequency: "Not Required",
    });
   const [stepOneError, setStepOneError] = useState({});
   const [displayStep, setDisplayStep] = useState(1);
   const [updateMessage, setUpdateMessage] = useState(false);
   const [posFrequency, setPosFrequency] = useState("low");
   const [contentvalues, setContactValues] = useState({});
   const [shiftsList, setShiftsList] = useState([]);
   const [customTaskList, setCustomTaskList] = useState([]);
   const [SummaryList, setSummaryList] = useState([]);
   const [taskList, settaskList] = useState([]);
   const [stepFourError, setStepFourError] = useState({});
   const [stepThreeError, setStepThreeError] = useState({});
  const { clientId } = useParams();
  const location = useLocation();
  const [targetStep, setTargetStep] = useState(null);
  const [hasJumped, setHasJumped] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const { toast } = useToast();

function base64ToFile(base64String, filename = `clientLogo_${Date.now()}.png`) {
  const arr = base64String.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

function isBase64Image(str) {
  return typeof str === "string" && /^data:image\/[a-zA-Z]+;base64,/.test(str);
}

function getExtensionFromBase64(base64String) {
  const match = base64String.match(/data:(.*?);/);
  if (!match) return null;
  const mime = match[1];
  const ext = mime.split('/')[1];
  return ext;
}

  const getClientDetails = (clientId) => {
    if (typeof clientId !== "undefined" && clientId !== "") {
      commonContext?.setLoader(true);
      getClient(
        clientId,
        (res) => {
          if (res?.status === true) {
            setEditData(res?.data);
            setPosFrequency(res?.data?.posFrequency || "low");
          }
          commonContext?.setLoader(false);
        },
        (_resError) => {
          commonContext?.setLoader(false);
        }
      );
    } else {
      commonContext?.setLoader(false);
    }
  };

  useEffect(() => {
    getClientDetails(clientId);
  }, [clientId]);

  const getCompanyDetails = async (companyId) => {
    try {
      if (typeof companyId !== "undefined" && companyId !== "") {
        commonContext?.setLoader(true);
        const [settingsRes, employeeRes] = await Promise.all([
          new Promise((resolve, reject) => {
            getSettings(
              "proofOfService_settings",
              companyId,
              (res) => resolve(res?.data),
              (err) => reject(err)
            );
          }),
          new Promise((resolve, reject) => {
            getEmployee(
              companyId,
              (res) => resolve(res),
              (err) => reject(err)
            );
          }),
        ]);

        if (employeeRes?.status === true) {
          setCompanyData(employeeRes?.data);
        }

        const filteredData = settingsRes?.filter((item) => !item.deleted);
        setSettingData(filteredData?.length ? filteredData : []);
      }
    } catch (error) {
      console.error(error);
    } finally {
      commonContext?.setLoader(false);
    }
  };

  useEffect(() => {
    getCompanyDetails(companyId);
  }, [companyId]);

  const onDeleteClient = async () => {
    confirm("Are you sure you want to permanently remove this client?")
      .then(() => {
        rundeleteClient();
      })
      .catch(() => {
        console.log("Cancel clicked!");
      });
  };

  const shiftNames =
    stepContentValues?.shiftsList !== "undefined"
      ? stepContentValues?.shiftsList?.map((shna) => {
          let titlename = "";
          if (shna.titlen > 0) {
            titlename = `${shna.title}-${shna.titlen}`;
          } else {
            titlename = `${shna.title}`;
          }

          return titlename;
        })
      : "";

  const normalshifts = shiftNames?.filter((items) => items !== "Opentasks");
  const registerClient = async (newClientData, logo, options) => {
    commonContext?.setLoader(true);
    let primarycontact = stepContentValues?.contact?.primary[0];
    let acuityClientData = {
      firstName: (
        stepContentValues?.firstName ||
        stepContentValues?.stepContent?.firstName ||
        stepContentValues?.clientName
      )?.trim(),
      lastName: (
        stepContentValues?.lastName ||
        stepContentValues?.stepContent?.lastName ||
        primarycontact?.name
      )?.trim(),
      email: primarycontact?.email,
      phone: primarycontact?.mobileNumber,
      notes: normalshifts?.toString(),
    };

    if (!newClientData.industryTypeOther) {
      delete newClientData.industryTypeOther;
    }
    await updateClient(
      auth?.newClientId,
      {
        ...newClientData,
        firstName: acuityClientData.firstName,
        lastName: acuityClientData.lastName,
      },
      acuityClientData,
      async (clientRes) => {
        if (clientRes?.data?.status === true) {
          if (logo) {
            await uploadLogo(logo, companyIds, async (logoUrl) => {
              await updateClient(
                clientRes.id,
                acuityClientData,
                { clientLogo: logoUrl },
                () => {},
                () => {}
              );
            });
          }
          commonContext?.setLoader(false);
          if (options && options?.finalsubmit === true) {
            const shouldCreateAnother = await confirmnew({
              confirmation: "Client is created successfully. Do you want to create another client?",
            });
            toast?.({
              title: "Success",
              description: "Client is created Successfully",
              variant: "default",
            });
            if (shouldCreateAnother) {
              window.location.reload();
            } else {
              history("/peoples/manageClient");
            }
          } else if (options && options?.step4 === true) {
            setDisplayStep(5);
          }
        } else {
          commonContext?.setLoader(false);
        }
      },
      (empErrorRes) => {
        commonContext?.setLoader(false);
        let errordata = empErrorRes?.response?.data;
        let error = errordata?.error
          ? errordata?.error?.message
          : errordata?.message
          ? errordata?.message
          : "";
        console.error("Error", error);
      }
    );
  };

  const saveEachStep = async (newClientData, logo, options) => {
    const id = editData !== false ? clientId : auth.newClientId;
    try {
      const primaryContact = stepContentValues?.contact?.primary?.[0];
      const acuityClientData = {
        firstName:
          newClientData?.stepContent?.firstName?.trim() ||
          stepContentValues?.clientName?.trim(),
        lastName:
          newClientData?.stepContent?.lastName?.trim() ||
          primaryContact?.name?.trim(),
      };

      if (options?.step1) {
        commonContext?.setLoader(true);

        let clientResponse;
        if (editData !== false) {
          clientResponse = await updateClient(
            id,
            {
              ...newClientData?.stepContent,
              firstName: acuityClientData.firstName,
              lastName: acuityClientData.lastName,
            },
            acuityClientData
          );
        } else {
          if (auth.newClientId) {
            clientResponse = await updateClient(
              auth.newClientId,
              newClientData,
              acuityClientData
            );
          } else {
            clientResponse = await handleNewClient(
              newClientData,
              acuityClientData
            );
          }
        }
        if (clientResponse?.status) {
          if (logo) {
            try {
              const ext = getExtensionFromBase64(logo);
              const fileName = `clientLogo_${Date.now()}.${ext}`;
              const logoFile = base64ToFile(logo, fileName);
              const logoUrl = await uploadLogo(logoFile, companyIds);
              await updateClient(id, acuityClientData, { clientLogo: logoUrl });
            } catch (error) {
              console.error("Logo upload failed:", error);
            }
          }
        } else {
          console.error("Failed to update/add client:", clientResponse);
        }

        commonContext?.setLoader(false);
        return clientResponse;
      } else if (newClientData?.contact) {
        commonContext?.setLoader(true);

        const contactRes = await handleContactUpdate(
          newClientData?.contact,
          id,
          logo
        );

        commonContext?.setLoader(false);
        return contactRes;
      }
    } catch (error) {
      console.error("Error in saveEachStep:", error);
      commonContext?.setLoader(false);
    }
  };

  const handleNewClient = async (newClientData, acuityClientData) => {
    try {
      const baseData = {
        ...newClientData?.stepContent,
      };

      if (auth.userProfile.role !== "superUser") {
        baseData.companyId =
          auth.userProfile.role === "companyUser"
            ? auth.userProfile.id
            : auth.userProfile.companyId;
      }
      const requestData = {
        ...baseData,
        firstName: acuityClientData?.firstName || "",
        lastName: acuityClientData?.lastName || "",
      };
      const clientResponse = await addClient(requestData, acuityClientData);

      if (clientResponse?.status) {
        const clientId = clientResponse?.data?.id;
        auth.setNewClientId(clientId);
        return clientResponse;
      } else {
        return (
          clientResponse || {
            status: false,
            message: "Unknown error occurred.",
          }
        );
      }
    } catch (error) {
      return {
        status: false,
        message: error.message || "An unexpected error occurred.",
      };
    }
  };

  const handleContactUpdate = async (
    contactData,
    clientId,
    logo
  ) => {
    try {
      let contact = [];
      if (contactData) {
        let primaryContact = contactData?.primary;
        if (primaryContact && primaryContact.length > 0) {
          primaryContact.map((pitem) => {
            contact.push({ ...pitem, type: "primary" });
            return pitem;
          });
        }
        let additionalContact = contactData?.additional;
        if (additionalContact && additionalContact.length > 0) {
          additionalContact.map((pitem) => {
            contact.push({ ...pitem, type: "additional" });
            return pitem;
          });
        }
      }
      const data = { contact: contact };
      const clientResponse = await updateClient(clientId, data);
      if (clientResponse?.status === false) {
        const errorCode = clientResponse?.message?.code;
        // eslint-disable-next-line no-unused-vars
        const errorMessage = clientResponse?.message?.message;
        goToStep(2);
        if (errorCode === "auth/email-already-exists") {
          setStepError((prevErrors) => ({
            ...prevErrors,
            primary: prevErrors.primary
              ? prevErrors.primary.map((err, _index) => ({
                  ...err,
                  emailExists: true,
                }))
              : [{ emailExists: true }],
          }));
        }
        return;
      }
      if(editData !== false){
        getClient(
          clientId,
          (res) => {
            if (res?.status === true) {
              setEditData(res?.data);
            }
          })
        }
      if (logo) {
        const ext = getExtensionFromBase64(logo);
        const fileName = `clientLogo_${Date.now()}.${ext}`;
        const logoFile = base64ToFile(logo, fileName);
        const logoUrl = await uploadLogo(logoFile, companyIds);
        await updateClient(clientId, { clientLogo: logoUrl });
      }
    } catch (error) {
      console.error("Error in handleContactUpdate:", error);
    }
  };

  let primarycontacttwo = stepContentValues?.contact?.primary?.[0];

  let acuityClientData = {
    firstName: (
      stepContentValues?.firstName ||
      stepContentValues?.stepContent?.firstName ||
      stepContentValues?.clientName
    )?.trim(),
    lastName: (
      stepContentValues?.lastName ||
      stepContentValues?.stepContent?.lastName ||
      primarycontacttwo?.name
    )?.trim(),
    email: primarycontacttwo?.email,
    phone: primarycontacttwo?.mobileNumber,
    notes: normalshifts?.toString(),
  };
  const runupdateClient = async (newClientData, logo, options) => {
    commonContext?.setLoader(true);
    let updateData = {};
    [
      "clientName",
      "industryType",
      "industryTypeOther",
      "summaryReportFrequency",
      "clientLogo",
      "contact",
      "shiftData",
      "customTaskList",
      "addressInfo",
      // "status",
    ].map((fieldItem) => {
      if (editData[fieldItem] !== newClientData[fieldItem]) {
        updateData[fieldItem] = newClientData[fieldItem];
      }
      return fieldItem;
    });
    updateData = {
      ...updateData,
      timeZone:
        stepContentValues?.timeZone || stepContentValues?.stepContent?.timeZone,
      firstName: (
        stepContentValues?.firstName ||
        stepContentValues?.stepContent?.firstName ||
        stepContentValues?.clientName
      )?.trim(),
      lastName: (
        stepContentValues?.lastName ||
        stepContentValues?.stepContent?.lastName ||
        primarycontacttwo?.name
      )?.trim(),
      ...(settingsData?.[0]?.proofOfService === true && { posFrequency, }),
    };

    await updateClient(
      clientId,
      updateData,
      acuityClientData,
      async (_clientRes) => {
        if (logo) {
          let logoUrl = logo;
          if (isBase64Image(logo)) {
            const ext = getExtensionFromBase64(logo);
            if (ext) {
              const fileName = `clientLogo_${Date.now()}.${ext}`;
              const logoFile = base64ToFile(logo, fileName);
              logoUrl = await uploadLogo(logoFile, companyIds);
            } else {
              console.log("Invalid base64 logo format");
            }
          }
          await updateClient(clientId, acuityClientData, { clientLogo: logoUrl });
        }
        commonContext?.setLoader(false);
        if (options && options?.finalsubmit === true) {
          confirm("Client is Updated Successfully", { cancel: false }).then(() => {
            history("/peoples/manageClient");
          });
        toast?.({
          title: "Success",
          description: "Client is Updated Successfully",
          variant: "default",
        });

          onCancelAll();
        } else if (options && options?.step4 === true) {
          setDisplayStep(5);
        }
      },
      (_clientErrorRes) => {
        commonContext?.setLoader(false);
      }
    );
  };

  const rundeleteClient = async () => {
    let primarycontactthr;
    let acuityClientDatadele;
    if (editData) {
      primarycontactthr = editData?.contact?.[0];
      acuityClientDatadele = {
        firstName: editData?.firstName
          ? editData?.firstName
          : editData?.clientName,
        lastName: editData?.lastName
          ? editData?.lastName
          : primarycontactthr?.name,
      };
    }

    commonContext?.setLoader(true);
    deleteClient(
      clientId,
      acuityClientDatadele,
      (res) => {
        if (res?.status === true) {
          commonContext?.setLoader(false);
          confirm("Client is Deleted Successfully", { cancel: false }).then(() => {
            history("/peoples/manageClient");
          });

        toast?.({
          title: "Success",
          description: "Client is Deleted Successfully",
          variant: "default",
        });

          onCancelAll();
        } else {
          commonContext?.setLoader(false);
        }
      },
      (empErrorRes) => {
        commonContext?.setLoader(false);
        let errordata = empErrorRes?.response?.data;
        console.log("error", errordata);
      }
    );
  };

  const goNext = () => {
    setDisplayStep(displayStep + 1);
  };

  const goToStep = (step) => {
    setCurrentStep(step);
  };

  EventEmitter.subscribe("client_ChangeFormStep", goToStep);

   const setStepThreeData = (editData) => {
     const editPrimary =
       editData?.contact?.filter((c) => c?.type === "primary") || [];
     const editAdditional =
       editData?.contact?.filter((c) => c?.type === "additional") || [];

     const allPrimary = [...editPrimary];
     const allAdditional = [...editAdditional];

     setContactValues({
       primary: allPrimary,
       additional: allAdditional,
     });

     if (editData?.shiftData) {
       let shfitdata = [...Object.keys(editData?.shiftData)]?.map((shiftId) => {
         let inShiftData = editData?.shiftData[shiftId];
         let inShiftDataKeys = Object.keys(inShiftData);
         let shiftItemData = inShiftData[inShiftDataKeys[0]];
         return {
           shiftId: shiftId,
           title: shiftItemData?.title,
           titlen: shiftItemData?.titlen,
           day: shiftItemData?.day,
           status: true,
           startTime: shiftItemData?.timeRange?.startTime,
           endTime: shiftItemData?.timeRange?.endTime,
           startDate: shiftItemData?.timeRange?.startDate,
           endDate: shiftItemData?.timeRange?.endDate,
           opentasksstatus: shiftItemData?.timeRange?.opentasksstatus,
         };
       });

       setShiftsList(shfitdata);
     } else if (editData?.shiftsList) {
       let shfitdata = [...Object.keys(editData?.shiftsList)]?.map((shiftId) => {
         let inShiftData = editData?.shiftsList[shiftId];
         return {
           shiftId: shiftId,
           title: inShiftData?.title,
           titlen: inShiftData?.titlen,
           day: inShiftData?.day,
           status: true,
           startTime: inShiftData?.timeRange?.startTime,
           endTime: inShiftData?.timeRange?.endTime,
           startDate: inShiftData?.timeRange?.startDate,
           endDate: inShiftData?.timeRange?.endDate,
           opentasksstatus: inShiftData?.timeRange?.opentasksstatus,
         };
       });

       setShiftsList(shfitdata);
     }

     let summaryDataEdit = [];
     if (editData?.shiftData) {
       [...Object.keys(editData?.shiftData)]?.map((shiftId) => {
         let inShiftData = editData?.shiftData[shiftId];
         let inShiftTasksKeys = Object.keys(inShiftData);
         if (inShiftTasksKeys?.length > 0) {
           inShiftTasksKeys.map((taskItemId) => {
             let taskItem = inShiftData[taskItemId];
             let shiftAllData = props?.stepContentValues?.shiftsList?.filter(
               (allsitem) => allsitem?.shiftId === shiftId
             );
             shiftAllData =
               shiftAllData?.length > 0
                 ? shiftAllData[0]
                 : { shiftId: shiftId, title: taskItem?.title };
             summaryDataEdit.push({
               id: taskItemId,
               frequency: taskItem?.frequency,
               tasks: taskItem?.tasksList,
               shift: shiftAllData,
              //  taskFrequency: taskItem?.taskFrequency || 0,
             });
             return taskItem;
           });
         }
         return shiftId;
       });
     } else if (editData?.SummaryList) {
       [...Object.keys(editData?.SummaryList)]?.map((shiftId) => {
         let inShiftData = editData?.SummaryList[shiftId];
         if (inShiftData?.tasks?.length > 0) {
           summaryDataEdit.push({
             id: inShiftData?.id,
             frequency: inShiftData?.frequency,
             tasks: inShiftData?.tasks,
             shift: inShiftData?.shift,
            //  taskFrequency: inShiftData?.taskFrequency || 0,
           });
           return inShiftData;
         }
         return shiftId;
       });
     }
     let customTasksList = [];
     if (editData?.customTaskList) {
       customTasksList = [
         ...Object.entries(editData?.customTaskList)?.map(([key, value]) => {
           return {
             taskId: key,
             custom: true,
             ...value,
           };
         }),
       ];
     }
     setCustomTaskList(customTasksList);
     setSummaryList(summaryDataEdit);
   };

  useEffect(() => {
    if (editData !== false && editData && !hasJumped) {
      setStepThreeData(editData);
      if(location.state?.jumpToStep && targetStep === null){
        setTargetStep(location.state?.jumpToStep);
        window.history.replaceState({}, document.title);
      }
    }
  }, [editData]);

  useEffect(() => {
  const jumpToTargetStep = async () => {
    if (editData !== false && editData && targetStep && !hasJumped) {
      commonContext?.setLoader(true);
      
      try {
        await handleStepFlow(targetStep - 1);
        
        await new Promise(resolve => setTimeout(resolve, 300));
        
        setDisplayStep(targetStep);
        
        setHasJumped(true);
        
      } catch (error) {
        console.error("Error jumping to step:", error);
      } finally {
        commonContext?.setLoader(false);
      }
    }
  };
  
  jumpToTargetStep();
}, [editData, targetStep]);

  const getFinalDataForSave = (finalData) => {
    let contact = [];
    if (finalData?.contact) {
      let primaryContact = finalData?.contact?.primary;
      if (primaryContact && primaryContact.length > 0) {
        primaryContact.map((pitem) => {
          contact.push({ ...pitem, type: "primary" });
          return pitem;
        });
      }
      let additionalContact = finalData?.contact?.additional;
      if (additionalContact && additionalContact.length > 0) {
        additionalContact.map((pitem) => {
          contact.push({ ...pitem, type: "additional" });
          return pitem;
        });
      }
    }
    let shiftData = {};

    if (finalData?.SummaryList && finalData?.SummaryList?.length > 0) {
      let allshiftIds = finalData?.SummaryList?.map((sitem) => sitem?.shift);
      allshiftIds = getUniqueArray(allshiftIds);
      allshiftIds.length > 0 &&
        allshiftIds.map((shiftItemId) => {
          let shiftItems = finalData?.SummaryList?.filter(
            (sitem) => sitem?.shift === shiftItemId
          );
          let saveShiftItems = {};

          shiftItems?.forEach((shiftItem) => {
            const matchedShift = finalData?.shiftsList?.find(
              (shift) => shift.shiftId === shiftItem.shift.shiftId
            );

            let datanew = {
              frequency: shiftItem?.frequency,
              title: matchedShift?.title || "",
              // titlen: matchedShift?.titlen || 0,
              titlen: 0,
              // day: matchedShift?.day || [],
              tasksList: shiftItem?.tasks,
              // taskFrequency: shiftItem?.taskFrequency || 0,
              timeRange: {
                startTime: matchedShift?.startTime || "",
                endTime: matchedShift?.endTime || "",
                startDate: matchedShift?.startDate || "",
                endDate: matchedShift?.endDate || "",
                opentasksstatus: matchedShift?.opentasksstatus || false,
              },
            };

            saveShiftItems = {
              ...saveShiftItems,
              [shiftItem?.id]: datanew,
            };
          });
          shiftData = { ...shiftData, [shiftItemId?.shiftId]: saveShiftItems };
          return shiftItemId;
        });
    }

    let FinalDataforsave = {
      clientName: finalData?.clientName || finalData?.stepContent?.clientName,
      industryType:
        finalData?.industryType || finalData?.stepContent?.industryType,
      industryTypeOther:
        finalData?.industryTypeOther ||
        finalData?.stepContent?.industryTypeOther,
      summaryReportFrequency:
        finalData?.summaryReportFrequency ||
        finalData?.stepContent?.summaryReportFrequency,
      clientLogo: finalData?.stepContent?.clientLogo ? finalData?.stepContent?.clientLogo : "",
      contact: contact,
      shiftData: shiftData,
      customTaskList: finalData?.customTaskList,
      status: clientId ? true : !shiftData || Object.keys(shiftData)?.length === 0 ? false : true,
      timeZone: finalData?.timeZone || finalData?.stepContent?.timeZone,
      posFrequency: posFrequency,
      addressInfo:
        finalData?.addressInfo || finalData?.stepContent?.addressInfo,
      // userCreation: finalData?.userCreation,
      additionalNotes: finalData?.additionalNotes || "",
    };
    return FinalDataforsave;
  };

  const validateAndGoNext = async (stepContent, options) => {
    if (options && options?.step4 === true) {
      let finalData = { ...stepContentValues, ...stepContent };
      setStepContentValue(finalData);
      let FinalDataforsave = getFinalDataForSave(finalData);
      if (editData !== false) {
        runupdateClient(FinalDataforsave, finalData?.stepContent?.clientLogo, options);
      } else {
        registerClient(FinalDataforsave, finalData?.stepContent?.clientLogo, options);
      }
    } else if (options && options?.finalsubmit === true) {
      let finalData = { ...stepContentValues };
      setStepContentValue(finalData);
      let FinalDataforsave = getFinalDataForSave(finalData);
      if (editData !== false) {
        runupdateClient(FinalDataforsave, finalData?.stepContent?.clientLogo, options);
      } else {
        registerClient(FinalDataforsave, finalData?.stepContent?.clientLogo, options);
      }
    } else {
      setStepContentValue({ ...stepContentValues, ...stepContent });
      let finalData = { ...stepContentValues, ...stepContent };
      // eslint-disable-next-line no-unused-vars
      let FinalDataforsave = getFinalDataForSave(finalData);
      saveEachStep({ ...stepContent }, finalData?.stepContent?.clientLogo, options);
      goNext();
    }
  };

  const onCancelAll = () => {
    if (clientId && clientId !== "") {
      history("/peoples/manageClient");
    }
    setDisplayStep(1);
  };

  const ResetPasswordLink = async () => {
    commonContext?.setLoader(true);
    const email = editData?.contact?.[0]?.email || "";
    try {
      await forgotPasswordUser(email, () => {});
      commonContext?.setLoader(false);
      alert("Reset Password Link sent to User's Email...");
    } catch (error) {
      commonContext?.setLoader(false);
      console.error("Error resetting password:", error);
      alert("An error occurred. Please try again.");
    }
  };

  const onResetPassword = async () => {
    await confirm(
      "Are you Sure you want to Send Reset Password Link to this client?"
    ).then(
      () => {
        ResetPasswordLink();
      },
      () => {
        console.log("cancel!");
      }
    );
  };

  const stepContentDataFunction = async (accumulatedData = null) => {
    const {
      clientName,
      industryType,
      industryTypeOther,
      summaryReportFrequency,
      firstName,
      lastName,
      timeZone,
      companyId,
      addressInfo,
    } = stepContent;

    let errormessages = stepOneError;
    let isValid = true;
    if (
      typeof clientName === "undefined" ||
      clientName === undefined ||
      clientName === ""
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        clientName: "Company Name is Required",
      };
    }
    if (
      typeof firstName === "undefined" ||
      firstName === undefined ||
      firstName === ""
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        firstName: "First Name is Required",
      };
    }
    if (
      typeof lastName === "undefined" ||
      lastName === undefined ||
      lastName === ""
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        lastName: "Last Name is Required",
      };
    }
    if (typeof industryType === "undefined" || industryType === "") {
      isValid = false;
      errormessages = {
        ...errormessages,
        industryType: "Industry Type is Required",
      };
    } else if (
      industryType === "Other" &&
      (typeof industryTypeOther === "undefined" || industryTypeOther === "")
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        industryTypeOther: "Industry Type Name is Required",
      };
    } else {
      errormessages = {
        ...errormessages,
        industryType: "",
        industryTypeOther: "",
      };
    }
    if (
      typeof summaryReportFrequency == "undefined" ||
      summaryReportFrequency === ""
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        summaryReportFrequency: "Summary Report Frequency is Required",
      };
    } else {
      errormessages = { ...errormessages, summaryReportFrequency: "" };
    }
    if (typeof timeZone == "undefined" || timeZone === "") {
      isValid = false;
      errormessages = {
        ...errormessages,
        timeZone: "Time Zone is Required",
      };
    } else {
      errormessages = { ...errormessages, timeZone: "" };
    }
    if (auth.userProfile.role === "superUser") {
      if (typeof companyId == "undefined" || companyId === "") {
        isValid = false;
        errormessages = {
          ...errormessages,
          companyId: "Company is Required",
        };
      } else {
        errormessages = { ...errormessages, timeZone: "" };
      }
    }
    // Validate Address Information
    if (!addressInfo?.address || addressInfo?.address.trim() === "") {
      isValid = false;
      errormessages.address = "Address is Required";
    } else {
      errormessages.address = "";
    }
    if (!addressInfo?.city || addressInfo?.city.trim() === "") {
      isValid = false;
      errormessages.city = "City is Required";
    } else {
      errormessages.city = "";
    }
    if (!addressInfo?.state || addressInfo?.state.trim() === "") {
      isValid = false;
      errormessages.state = "State is Required";
    } else {
      errormessages.state = "";
    }
    if (!addressInfo?.zip || addressInfo?.zip.trim() === "") {
      isValid = false;
      errormessages.zip = "Zip Code is Required";
    } else {
      errormessages.zip = "";
    }
    setStepOneError(errormessages);
    if (isValid) {
      const baseData = accumulatedData || stepContentValues;
      const updatedValues = { ...baseData, stepContent };
      setStepContentValue(updatedValues);

      // eslint-disable-next-line no-unused-vars
      const finalData = getFinalDataForSave(updatedValues);
      await saveEachStep({ stepContent }, updatedValues?.stepContent?.clientLogo, {
        step1: true,
      });
      return updatedValues;
    }
    return accumulatedData || stepContentValues;
  };

  const buildContactFromEditData = () => {
    const editPrimary =
      editData?.contact?.filter((c) => c?.type === "primary") || [];

    const editAdditional =
      editData?.contact?.filter((c) => c?.type === "additional") || [];

    return {
      primary: [...editPrimary],
      additional: [...editAdditional],
    };
  };

  const mergeContactSafely = (baseData, contentvalues) => {
    if (contentvalues?.primary?.length === 0 || contentvalues?.additional?.length === 0) {
      const values = buildContactFromEditData();
      return { ...baseData, contact: values };
    } else {
       return {
        ...baseData,
        contact: contentvalues || { primary: [], additional: [] },
      };
    }
  };

 const contactDataFunction = async (accumulatedData = null) => {
    const baseData = accumulatedData || stepContentValues;

    const updatedValues = mergeContactSafely(
      baseData,
      contentvalues
    );

    setStepContentValue(updatedValues);

    const finalData = getFinalDataForSave(updatedValues);
    await saveEachStep(
      { contact: updatedValues.contact },
      updatedValues?.stepContent?.clientLogo
    );
    return updatedValues;
  };

  const shiftDataFunction = async (accumulatedData = null) => {
    let errormessages = stepThreeError;
    let isValid = true;
    if (
      typeof shiftsList === "undefined" ||
      shiftsList === "" ||
      shiftsList?.length <= 0
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        shiftsList: "Must Create at least one Shift",
      };
    } else {
      errormessages = { ...errormessages, shiftsList: "" };
    }
    setStepThreeError(errormessages);
    if (isValid) {
      const baseData = accumulatedData || stepContentValues;
      const updatedValues = { ...baseData, shiftsList };
      setStepContentValue(updatedValues);

      // eslint-disable-next-line no-unused-vars
      const finalData = getFinalDataForSave(updatedValues);
      await saveEachStep({ shiftsList }, updatedValues?.stepContent?.clientLogo);
      return updatedValues;
    }
    return accumulatedData || stepContentValues;
  };

  const getTaskTitle = (task) => {
    let allTasks = [...taskList, ...customTaskList];
    let selectedTasks = allTasks?.filter(
      (sitem) => task === (sitem?.taskId ?? sitem?.id)
    );
    selectedTasks = selectedTasks[0];
    return selectedTasks?.title;
  };

  const taskDataFunction = async (accumulatedData = null) => {
    let errormessages = stepFourError;
    let isValid = true;
    if (
      typeof SummaryList === "undefined" ||
      SummaryList === "" ||
      SummaryList?.length <= 0
    ) {
      isValid = false;
      errormessages = {
        ...errormessages,
        SummaryList: "Must Create at least one Task Group",
      };
    } else {
      errormessages = { ...errormessages, SummaryList: "" };
    }

    setStepFourError(errormessages);
    if (isValid) {
      let SummaryListNew = SummaryList?.map((sitem) => {
        let tasksList = sitem?.tasks?.map((stitem) => {
          return { taskId: stitem, title: getTaskTitle(stitem) };
        });
        return { ...sitem, tasksList };
      });
      let customTasksListmap = {};
      customTaskList?.map((ctasklistitem) => {
        customTasksListmap[ctasklistitem.taskId] = {
          title: ctasklistitem?.title,
          description: ctasklistitem?.description,
          frequency: ctasklistitem?.frequency,
          shift: ctasklistitem?.shift,
          interval: ctasklistitem?.interval,
          startDate: ctasklistitem?.startDate || "",
          endDate: ctasklistitem?.endDate || "",
        };
        return ctasklistitem;
      });
      const baseData = accumulatedData || stepContentValues;
      const finalData = {
        ...baseData,
        customTaskList: customTasksListmap,
        SummaryList: SummaryListNew,
      };

      setStepContentValue(finalData);
      
      const finalDataForSave = getFinalDataForSave(finalData);

      if (editData !== false) {
        runupdateClient(finalDataForSave, finalData?.stepContent?.clientLogo);
      } else {
        registerClient(finalDataForSave, finalData?.stepContent?.clientLogo);
      }
        return finalData;
    }
    return accumulatedData || stepContentValues;
  };

  const handleStepFlow = async (targetStep) => {
    try {
      let accumulatedData = stepContentValues;
    
      if (targetStep >= 1) {
        accumulatedData = await stepContentDataFunction(accumulatedData);
      }
      
      if (targetStep >= 2) {
        accumulatedData = await contactDataFunction(accumulatedData);
      }
      
      if (targetStep >= 3) {
        accumulatedData = await shiftDataFunction(accumulatedData);
      }
      
      if (targetStep >= 4) {
        accumulatedData = await taskDataFunction(accumulatedData);
      }
      return accumulatedData;
    } catch (error) {
      console.error("Error in handleStepFlow:", error);
      commonContext?.setLoader(false);
    }
  };

  const handleTabClick = async (stepNumber) => {
    try {
      if (clientId) {
        commonContext?.setLoader(true);
        await handleStepFlow(stepNumber - 1);
        commonContext?.setLoader(false);
      }
      setDisplayStep(stepNumber);
      setUpdateMessage(false);
    } catch (error) {
      console.error("Error switching tabs:", error);
      commonContext?.setLoader(false);
    }
  };

  // const hasClientProfile = () => {
  //   if (!clientId) {
  //     return stepContentValues?.stepContent;
  //   }
  //   return editData?.clientName;
  // };

  // const hasContacts = () => {
  //   if (!clientId) {
  //     return (
  //       stepContentValues?.contact?.primary?.length > 0 ||
  //       stepContentValues?.contact?.additional?.length > 0
  //     );
  //   }
  //   return (
  //     editData?.contact && Array.isArray(editData?.contact) && editData?.contact?.length > 0
  //   );
  // };

  // const hasShifts = () => {
  //   if (!clientId) {
  //     return (
  //       stepContentValues?.shiftsList?.length > 0
  //     );
  //   }
  //   return (
  //     editData?.shiftData && Object.keys(editData?.shiftData)?.length > 0
  //   );
  // };

  // const hasTasks = () => {
  //   if (!clientId) {
  //     return (
  //       stepContentValues?.customTaskList || stepContentValues?.SummaryList?.length > 0
  //     );
  //   }
  //   return (
  //     editData?.shiftData && Object.keys(editData?.shiftData)?.length > 0
  //   );
  // };

 const hasClientProfile = () => {
    if (!clientId) return true;
    return !!editData?.clientName;
  };

  const hasContacts = () => {
    if (!clientId) return true;
    return (
      editData?.contact &&
      Array.isArray(editData.contact) &&
      editData.contact.length > 0
    );
  };

  const hasShifts = () => {
    if (!clientId) return true;
    return (
      editData?.shiftData && Object.keys(editData.shiftData)?.length > 0
    );
  };

  const hasTasks = () => {
    if (!clientId) return true;
    return (
      editData?.shiftData && Object.keys(editData.shiftData)?.length > 0
    );
  };

  const isEmptyShiftData = !editData?.shiftData || Object.keys(editData?.shiftData)?.length === 0;

  return (
    <>
      <Container>
        <PageTitle
          pageTitle={
            typeof clientId !== "undefined" && clientId !== ""
              ? "Edit Client"
              : "Create Client"
          }
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Client", to: "/peoples/manageClient" },
          ]}
        />

        <div
          className={
            isMobile
              ? "d-flex delete p-10"
              : "d-flex flex-center delete flex-space-between pv-24 ph-32"
          }
          style={{
            maxWidth: isMobile ? "410px" : "1280px",
            margin: isMobile ? "0px" : "0px auto",
          }}
        >
          {typeof clientId !== "undefined" && clientId !== "" && (
            <>
              <h1 className="text-xl md:text-2xl font-bold tracking-tight dark:text-white ml-10">
                {editData?.clientName}  {editData?.status === false && isEmptyShiftData && (<span className={styles.support}> {editData?.status === false && isEmptyShiftData ? "Pending" : ""}</span> )}
              </h1>
            <div className="d-flex flex-center">
              <Button
                variant="outlined"
                className={isMobile ? "mv-10 mh-10" : "mr-12"}
                style={{
                  backgroundColor: "#FEF2F2",
                  color: "#DC2626",
                  border: "1px solid rgba(254, 202, 202, 1)",
                  padding: "8px 16px",
                }}
                onClick={onDeleteClient}
              >
                <Trash2 className="h-4 w-4 mr-8" />
                Delete
              </Button>
              {typeof clientId !== "undefined" &&
                clientId !== "" && (
                  <Button
                    variant="outlined"
                    className={isMobile ? "mv-10 mh-10" : "mr-12"}
                    style={{
                      backgroundColor: "#FEF2F2",
                      color: "#DC2626",
                      border: "1px solid rgba(254, 202, 202, 1)",
                      padding: "8px 16px",
                    }}
                    onClick={onResetPassword}
                  >
                    <RotateCcw className="h-4 w-4 mr-8" />
                    Reset Password
                  </Button>
                )}
            </div>
            </>
          )}
        </div>

        <div className={isMobile ? styles.tabs : `${styles.tabs} pv-24 ph-32`}>
          <div className={styles.tabBarWrapper}>
            <div className={styles.tabsList}>
              <Button
                className={`${styles.tabTrigger} ${
                  displayStep === 1 ? styles.activeTab : ""
                }`}
                onClick={() => setDisplayStep(1)}
              >
                <span
                  className={`${styles.mobilesideOnly} ${
                    displayStep === 1 ? styles.activeTabText : ""
                  }`}
                >
                  1. Profile
                </span>
                <span
                  className={`${styles.desktopsideOnly} ${
                    displayStep === 1 ? styles.activeTabText : ""
                  }`}
                >
                  1. Client Profile
                </span>
              </Button>

              <Button
                className={`${styles.tabTrigger} ${
                  displayStep === 2 ? styles.activeTab : ""
                }`}
                onClick={async() => {
                  handleTabClick(2);
                }}
                disabled={!hasClientProfile()}
              >
                <span
                  className={`${styles.mobilesideOnly} ${
                    displayStep === 2 ? styles.activeTabText : ""
                  }`}
                >
                  2. Contacts
                </span>
                <span
                  className={`${styles.desktopsideOnly} ${
                    displayStep === 2 ? styles.activeTabText : ""
                  }`}
                >
                  2. Contacts
                </span>
              </Button>

              <Button
                className={`${styles.tabTrigger} ${
                  displayStep === 3 ? styles.activeTab : ""
                }`}
                onClick={async() => {
                  handleTabClick(3);
                }}
                disabled={!hasContacts()}  
              >
                <span
                  className={`${styles.mobilesideOnly} ${
                    displayStep === 3 ? styles.activeTabText : ""
                  }`}
                >
                  3. Shifts
                </span>
                <span
                  className={`${styles.desktopsideOnly} ${
                    displayStep === 3 ? styles.activeTabText : ""
                  }`}
                >
                  3. Shifts
                </span>
              </Button>

              <Button
                className={`${styles.tabTrigger} ${
                  displayStep === 4 ? styles.activeTab : ""
                }`}
                onClick={async() => {
                  handleTabClick(4);
                }}
                disabled={!hasShifts()}
              >
                <span
                  className={`${styles.mobilesideOnly} ${
                    displayStep === 4 ? styles.activeTabText : ""
                  }`}
                >
                  4. Tasks
                </span>
                <span
                  className={`${styles.desktopsideOnly} ${
                    displayStep === 4 ? styles.activeTabText : ""
                  }`}
                >
                  4. Tasks
                </span>
              </Button>

              <Button
                className={`${styles.tabTrigger} ${
                  displayStep === 5 ? styles.activeTab : ""
                }`}
                onClick={async() => {
                  handleTabClick(5);
                }}
                disabled={!hasTasks()}
              >
                <span
                  className={`${styles.mobilesideOnly} ${
                    displayStep === 5 ? styles.activeTabText : ""
                  }`}
                >
                  5. Summary
                </span>
                <span
                  className={`${styles.desktopsideOnly} ${
                    displayStep === 5 ? styles.activeTabText : ""
                  }`}
                >
                  5. Summary
                </span>
              </Button>
            </div>
          </div>

          {displayStep === 1 && (
            <div className={styles.tabContent}>
              <Step1
                currentStep={currentStep}
                goToStep={goToStep}
                onCancelAll={onCancelAll}
                validateAndGoNext={validateAndGoNext}
                loading={loading}
                classes={classes}
                stepContentValues={stepContentValues}
                editData={editData}
                displayStep={displayStep}
                stepContent={stepContent}
                setStepContent={setStepContent}
                stepError={stepOneError}
                setStepError={setStepOneError}
              />
            </div>
          )}
          {displayStep === 2 && (
            <div className={styles.tabContent}>
              <Step2
                currentStep={currentStep}
                goToStep={goToStep}
                onCancelAll={onCancelAll}
                validateAndGoNext={validateAndGoNext}
                loading={loading}
                classes={classes}
                stepContentValues={stepContentValues}
                editData={editData}
                stepError={stepError}
                setStepError={setStepError}
                setDisplayStep={setDisplayStep}
                displayStep={displayStep}
                setStepContentValue={setStepContentValue}
                companyData={companyData}
                stepContent={contentvalues}
                setContactValues={setContactValues}
              />
            </div>
          )}

          {displayStep === 3 && (
            <div className={styles.tabContent}>
              <Step3
                currentStep={currentStep}
                goToStep={goToStep}
                onCancelAll={onCancelAll}
                validateAndGoNext={validateAndGoNext}
                loading={loading}
                classes={classes}
                stepContentValues={stepContentValues}
                editData={editData}
                setDisplayStep={setDisplayStep}
                displayStep={displayStep}
                shiftsList={shiftsList}
                setShiftsList={setShiftsList}
                stepError={stepThreeError}
                setStepError={setStepThreeError}
                setPosFrequency={setPosFrequency}
                posFrequency={posFrequency}
                settingsData={settingsData}
              />
            </div>
          )}

          {displayStep === 4 && (
            <div className={styles.tabContent}>
              <Step4
                currentStep={currentStep}
                goToStep={goToStep}
                onCancelAll={onCancelAll}
                validateAndGoNext={validateAndGoNext}
                loading={loading}
                classes={classes}
                stepContentValues={stepContentValues}
                editData={editData}
                setDisplayStep={setDisplayStep}
                displayStep={displayStep}
                SummaryList={SummaryList}
                setSummaryList={setSummaryList}
                customTaskList={customTaskList}
                setCustomTaskList={setCustomTaskList}
                taskList={taskList}
                settaskList={settaskList}
                stepError={stepFourError}
                setStepError={setStepFourError}
                setUpdateMessage={setUpdateMessage}
                updateMessage={updateMessage}
                settingsData={settingsData}
              />
            </div>
          )}
          {displayStep === 5 && (
            <div className={styles.tabContent}>
              <Step5
                stepContentValues={stepContentValues}
                onCancelAll={onCancelAll}
                validateAndGoNext={validateAndGoNext}
                loading={loading}
                setDisplayStep={setDisplayStep}
              />
            </div>
          )}
        </div>
      </Container>
    </>
  );
};

export default CreateClient;
